import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Trophy, Award, Star, Gift, BadgeCheck } from "lucide-react";
import "bootstrap/dist/css/bootstrap.min.css";
import FromPageIndicator from "../Common/FromPageIndicator";

const AwardsAndHonors = () => {
  const awards = [
    {
      id: 1,
      title: "PTW – Young Medical Physics Student Award",
      description:
        "This award was instituted in 2017 to encourage young Medical Physics students. This award is given to best oral/poster paper presenters as adjudged by scientific committee.",
      year: "2017",
      icon: "trophy",
    },
    {
      id: 2,
      title: "Prof. M. Jagadeesan Best Paper Award",
      description:
        "This award was instituted in the year 2005 by Prof. M. Jagadeesan, M.D, Professor of Radiation Oncology. This award is given to best oral paper presenters as adjudged by scientific committee.",
      year: "2005",
      icon: "award",
    },
    {
      id: 3,
      title: "Prof. T. M. B. Nedungadi Best Paper Award",
      description:
        "This award was instituted in the year 2007 by Prof. T. M. B. Nedungadi, M.Sc, Professor of Radiology Physics. This award is given to best oral paper presenters as adjudged by scientific committee.",
      year: "2007",
      icon: "star",
    },
    {
      id: 4,
      title: "Apollo Best Researcher Award",
      description:
        "This prestigious award is presented by Apollo Cancer Centres. It is awarded to the best Oral or Poster paper presenters, from both faculty and student categories, as adjudged by the Scientific Committee. The award aims to encourage high-quality research in Medical Physics.",
      year: "",
      icon: "medal",
    },
    {
      id: 5,
      title: "Prof Dr.P.Kaliyappan  Best Innovation Award in Medical Physics.",
      description:
        "This award was instituted in the year 2025 by Prof.Dr.P.Kaliyappan, Ph.D, Professor of Medical Physics to motivate and encourage Medical Physics students/ Research scholars and Medical Physics professionals to sustain their service to the healthcare system and to the cancer patients treatment.",
      year: "2025",
      icon: "medal",
    },
  ];

  const renderIcon = (iconName, id) => {
    if (id === 5) {
      return <BadgeCheck size={24} className="text-primary" />;
    }
    switch (iconName) {
      case "trophy":
        return <Trophy size={24} className="text-primary" />;
      case "award":
        return <Award size={24} className="text-primary" />;
      case "star":
        return <Star size={24} className="text-primary" />;
      case "medal":
      default:
        return <Gift size={24} className="text-primary" />;
    }
  };

  return (
    <div style={{ backgroundColor: "#F5FAFC" }}>
      <FromPageIndicator />
      <Container>
        <Row className="mb-5 mt-3">
          <Col className="text-center">
            <h2 className="display-5 fw-bold" style={{ color: "#1B5F7D" }}>
              Awards & Honors
            </h2>
            <div
              style={{
                width: "70px",
                height: "4px",
                background: "#1B5F7D",
                margin: "15px auto",
                borderRadius: "2px",
              }}
            ></div>
          </Col>
        </Row>
        <Row>
          {awards.map((award) => (
            <Col key={award.id} xs={12} md={6} className="mb-4">
              <Card
                className="h-100 shadow-sm"
                style={{
                  border: "2px solid #1B5F7D",
                  borderRadius: "18px",
                  boxShadow: "0 2px 12px rgba(27,95,125,0.10)",
                  transition: "transform 0.3s",
                  cursor: "pointer",
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = "translateY(-5px)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.transform = "translateY(0)")
                }
              >
                <Card.Body className="d-flex flex-column">
                  <div className="d-flex mb-3">
                    <div
                      className="me-3 d-flex align-items-center justify-content-center rounded-circle"
                      style={{
                        width: "50px",
                        height: "50px",
                        backgroundColor: "rgba(27,95,125,0.12)",
                        color: "#1B5F7D",
                      }}
                    >
                      {renderIcon(award.icon, award.id)}
                    </div>
                    <div>
                      <h4 className="fw-bold mb-1" style={{ color: "#1B5F7D" }}>
                        {award.title}
                      </h4>
                      {award.year && (
                        <small className="text-muted">
                          Established in {award.year}
                        </small>
                      )}
                    </div>
                  </div>
                  <Card.Text
                    className="text-secondary"
                    style={{ color: "#195f7d" }}
                  >
                    {award.description}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default AwardsAndHonors;
